<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="internationalAirFareCapObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for any flight between countries when the total cost is above

                        <span class="rule-config-variable" @click="isEdit = !isEdit">{{
                            internationalAirFareCapObj.value
                                ? this.$options.filters.formatCurrency(internationalAirFareCapObj.value, 0, currencyCode)
                                : "N/A"
                        }}

                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">

                    <b-switch :rounded="true" :value="internationalAirFareCapObj.isActive"
                        v-model="internationalAirFareCapObj.isActive" @input="internationalAirfareCap"
                        :left-label="true">{{ internationalAirFareCapObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy">
            <InternationalAirFareCap @internationalAirFareCap="getValue"
                :internationalAirFare="internationalAirFareCapObj.value" />
            <p>Enter amount</p>
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="internationalAirFareCapObj.isActive && !isEdit" :ruleObj="internationalAirFareCapObj"
            :title="title" @save="updateActions" />
    </div>
</template>
<script>
import InternationalAirFareCap from '../CommonRules/InternationalAirFareCap.vue';
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        InternationalAirFareCap,
        StandardRuleActions
    },
    data() {
        return {
            internationalAirFareCapObj: this.value ? this.value : {
                name: "internationalAirfareCap",
                isActive: false,
                value: 1500,
                type: 'air',
                message: '',
            },
            isEdit: false,
            emitedValue: null,
            title: 'International airfare cap'
        }
    },
    computed: {
        currencyCode() {
            return this.$store.getters['travellersAndTrips/getUserDefaultCurrency'];
        },
    },
    methods: {
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue || this.emitedValue == '') {
                this.internationalAirFareCapObj.value = this.emitedValue;
            }

            this.buildMessage();
        },
        getValue(val) {
            this.emitedValue = val;
        },
        internationalAirfareCap() {
            
            if (!this.internationalAirFareCapObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        clearActionParams() {
        // Reset to default actions when rule is not active ()
            this.internationalAirFareCapObj.useCustomActions = false;
            delete this.internationalAirFareCapObj.visibility;
            delete this.internationalAirFareCapObj.approvalLevel;
            delete this.internationalAirFareCapObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into internationalAirFareCapObj
            this.internationalAirFareCapObj = { ...this.internationalAirFareCapObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams()
            }

            this.buildMessage();

            this.emitRuleObj();
        },
        emitRuleObj() {
            this.$emit("internationalAirfareCap", this.internationalAirFareCapObj);
        },
        buildMessage() {

            var string = 'Trigger for any flight between countries when the total cost is above';

            this.internationalAirFareCapObj.message = string + (this.internationalAirFareCapObj.value ? ' ' + this.$options.filters.formatCurrency(this.internationalAirFareCapObj.value, 0, this.currencyCode) : 'N/A');
        }
    },
    mounted() {
        this.internationalAirFareCapObj.type = 'air';

        this.emitRuleObj();
    },

    watch: {
        value: {
            handler(newVal, prevVal) {
                this.internationalAirFareCapObj = this.value;
                this.internationalAirFareCapObj.type = 'air';

                this.buildMessage();
                this.emitRuleObj();
            },
            deep: true,
        },
    },
}
</script>